import { render, staticRenderFns } from "./add-website.vue?vue&type=template&id=b4ef0d4a&scoped=true&"
import script from "./add-website.vue?vue&type=script&lang=js&"
export * from "./add-website.vue?vue&type=script&lang=js&"
import style0 from "./add-website.vue?vue&type=style&index=0&id=b4ef0d4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ef0d4a",
  null
  
)

export default component.exports